import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M19.6011 17.6994C17.868 20.0072 15.1083 21.5 12 21.5C8.89169 21.5 6.13205 20.0072 4.39888 17.6994L5.67082 18.3354C6.96595 15.7451 9.55322 15.25 12 15.25C14.4468 15.25 17.034 15.7451 18.3292 18.3354L19.6011 17.6994ZM19.6532 17.6295C18.5528 15.4565 16.7542 14.4739 14.9337 14.0493C16.1858 13.1406 17 11.6654 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 11.6654 7.8142 13.1406 9.06626 14.0493C7.2458 14.4739 5.44724 15.4565 4.34685 17.6295C3.186 16.054 2.5 14.1071 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 14.1071 20.814 16.054 19.6532 17.6295ZM12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
        <circle
            cx="12"
            cy="12"
            r="9.5"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
